import QuizValidation from './QuizValidation';

export default QuizValidation;
